/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Submit_Desc6Inputs */

const en_svc_browser_extensions_submit_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packaging, review-readiness, store assets, and privacy disclosures handled end-to-end.`)
};

const ar_svc_browser_extensions_submit_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغليف وجاهزية مراجعة وأصول متجر وإفصاحات خصوصية مُعالَجة من البداية للنهاية.`)
};

const bn_svc_browser_extensions_submit_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্যাকেজিং, রিভিউ-রেডিনেস, স্টোর অ্যাসেট ও প্রাইভেসি ডিসক্লোজার এন্ড-টু-এন্ড সামলানো।`)
};

const de_svc_browser_extensions_submit_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verpackung, Review-Reife, Store-Assets und Datenschutzerklärungen, durchgängig betreut.`)
};

const es_svc_browser_extensions_submit_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empaquetado, preparación para revisión, activos de la tienda y divulgaciones de privacidad manejados de un extremo a otro.`)
};

const fr_svc_browser_extensions_submit_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packaging, préparation à la review, assets du store et mentions de confidentialité, gérés de bout en bout.`)
};

const pt_svc_browser_extensions_submit_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacote, preparo para review, assets da loja e avisos de privacidade tratados de ponta a ponta.`)
};

const zh_svc_browser_extensions_submit_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打包、过审准备、商店素材和隐私声明，端到端搞定。`)
};

const tr_svc_browser_extensions_submit_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketleme, inceleme hazırlığı, mağaza asset'leri ve gizlilik açıklamaları uçtan uca halledilir.`)
};

const ru_svc_browser_extensions_submit_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упаковка, готовность к ревью, ассеты стора и disclosure приватности, всё end-to-end.`)
};

const pl_svc_browser_extensions_submit_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spakowanie, gotowość do review, assety sklepu i disclosury prywatności end-to-end.`)
};

/**
* | output |
* | --- |
* | "Packaging, review-readiness, store assets, and privacy disclosures handled end-to-end." |
*
* @param {Svc_Browser_Extensions_Submit_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_submit_desc6 = /** @type {((inputs?: Svc_Browser_Extensions_Submit_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Submit_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_submit_desc6(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_submit_desc6(inputs)
	if (locale === "de") return de_svc_browser_extensions_submit_desc6(inputs)
	if (locale === "es") return es_svc_browser_extensions_submit_desc6(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_submit_desc6(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_submit_desc6(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_submit_desc6(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_submit_desc6(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_submit_desc6(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_submit_desc6(inputs)
	return en_svc_browser_extensions_submit_desc6(inputs)
});
export { svc_browser_extensions_submit_desc6 as "svc_browser-extensions_SUBMIT_desc" }